module.exports = __webpack_public_path__ + "img/B-Senior.66a1cc27.png";